<template>
    <div>
      <div class="text-right">
        <button
          @click="handleDownload()"
          class="px-4 py-2 mb-4 bg-gray-50 border rounded-md text-black flex"
        >
          <img src="../../../assets/excel.png" alt="" />
          <span class="mx-3">Download</span>
        </button>
      </div>
  
      <div class="flex text-lg mb-4">
        <h1 class="pr-4 border-r uppercase font-bold">
          {{ $route.params.reportOn.replace(/_/g, " ") }}
        </h1>
        <h1 class="px-4 border-r">
          From:
          <span class="font-bold">{{
            $route.params.from | moment("ddd, MMM Do YYYY")
          }}</span>
        </h1>
        <h1 class="px-4">
          To:
          <span class="font-bold">{{
            $route.params.to | moment("ddd, MMM Do YYYY")
          }}</span>
        </h1>
      </div>
  
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th
              scope="col"
              class="
                px-6
                py-3
                text-left text-xs
                font-medium
                text-gray-500
                uppercase
                tracking-wider
              "
            >
              Date
            </th>
  
            <th
              scope="col"
              class="
                px-6
                py-3
                text-center text-xs
                font-medium
                text-gray-500
                uppercase
                tracking-wider
              "
            >
              Staff
            </th>
  
            <th
              scope="col"
              class="
                px-6
                py-3
                text-center text-xs
                font-medium
                text-gray-500
                uppercase
                tracking-wider
              "
            >
              Top Ups
            </th>
            <th
              scope="col"
              class="
                px-6
                py-3
                text-left text-xs
                font-medium
                text-gray-500
                uppercase
                tracking-wider
              "
            >
              Total Sales
            </th>
  
            <th
              scope="col"
              class="
                px-6
                py-3
                text-left text-xs
                font-medium
                text-gray-500
                uppercase
                tracking-wider
              "
            >
              Cash In Hand
            </th>
            <th
              scope="col"
              class="
                px-6
                py-3
                text-xs
                font-medium
                text-right text-gray-500
                uppercase
                tracking-wider
              "
            >
              Banked
            </th>
            <th
              scope="col"
              class="
                px-6
                py-3
                text-xs
                font-medium
                text-right text-gray-500
                uppercase
                tracking-wider
              "
            >
              Difference
            </th>
          </tr>
        </thead>
  
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(transaction, i) in data" :key="i">
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="flex items-center">
                <div class="ml-4">
                  <div class="text-sm font-medium text-gray-900">
                    {{ transaction.date }}
                  </div>
                </div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                {{ transaction.staff }}
              </div>
            </td>
  
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                GMD <b>{{ formatPrice(transaction.topup) }}</b>
              </div>
            </td>
  
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                GMD <b>{{ formatPrice(transaction.total_sales) }}</b>
              </div>
            </td>
  
            <td class="px-6 py-4 text-center whitespace-nowrap">
              <div class="text-sm font-bold text-gray-900">
                GMD <b>{{ formatPrice(transaction.cash_in_hand) }}</b>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                {{ transaction.banked ? 'Yes' : 'No' }}
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap  text-right">
              <div class="text-sm text-gray-900">
                <b>{{ formatPrice(transaction.difference) }}</b>
              </div>
            </td>
          </tr>
  
    
          <tr>
            <td class="px-6 py-4 whitespace-nowrap font-bold">Total</td>
            <td class="px-6 py-4 whitespace-nowrap"></td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                GMD <b>{{ formatPrice(totalTopUps) }}</b>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                GMD <b>{{ formatPrice(totalSales) }}</b>
        
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
                GMD <b>{{ formatPrice(totalCashInHand) }}</b>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-center">
              <div class="text-sm text-gray-900">
              </div>
            </td>

            <td class="px-6 py-4 whitespace-nowrap text-right">
                <div class="text-sm text-gray-900 ">
                  GMD <b>{{ formatPrice(totalDifference) }}</b>
                </div>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    props: ["data"],
  
    data: () => ({
      downloadLoading: false,
  
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
    }),
  
    computed: {

        totalTopUps: function () {
      return this.data.reduce((total, transaction) => total + transaction.topup, 0);
    },
    totalCashInHand: function () {
        return this.data.reduce((total, transaction) => total + transaction.cash_in_hand, 0);
      },
      totalSales: function () {
        return this.data.reduce((total, transaction) => total + transaction.total_sales, 0);
      },
     
        totalDifference: function () {
        return  this.totalCashInHand - (this.totalTopUps + this.totalSales);
      },
      

      
      totalTransactions: function () {
        let total = [];
  
        Object.entries(this.data).forEach(([key, val]) => {
          console.log(key);
          total.push(val.transactions);
        });
  
        return total.reduce(function (total, num) {
          return total + num;
        }, 0);
      },
  
      totalAmount: function () {
        let total = [];
  
        Object.entries(this.data).forEach(([key, val]) => {
          console.log(key);
          total.push(val.amount);
        });
  
        return total.reduce(function (total, num) {
          return total + num;
        }, 0);
      },
  
      totalCommission: function () {
        let total = [];
  
        Object.entries(this.data).forEach(([key, val]) => {
          console.log(key);
          total.push(val.commission);
        });
  
        return total.reduce(function (total, num) {
          return total + num;
        }, 0);
      },
  
      total: function () {
        let total = [];
  
        Object.entries(this.data).forEach(([key, val]) => {
          console.log(key);
          total.push(val.amount + val.commission);
        });
  
        return total.reduce(function (total, num) {
          return total + num;
        }, 0);
      },
    },
  
    methods: {
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
  
      
  
      getFileName() {
        return (
          this.$route.params.reportOn +
          "-" +
          this.$route.params.from +
          "-" +
          this.$route.params.to
        );
      },
  
      calculateTotal(data, key) {
    return data.reduce((total, transaction) => total + transaction[key], 0);
},


getTableHeaders(table) {
  const headerRow = table.querySelector("thead tr"); 
  const headers = [];
  headerRow.querySelectorAll("th").forEach((header) => {
    headers.push(header.textContent.trim());
  });
  return headers;
},
   
handleDownload() {
  this.downloadLoading = true;
  import("@/vendor/Export2Excel").then((excel) => {
    const tHeader = [
      "Date",
      "Staff",
      "Top Ups",
      "Total Sales",
      "Cash In Hand",
      "Banked",
      "Difference",
    ];

    const filterVal = [
      "date",
      "staff",
      "topup",
      "total_sales",
      "cash_in_hand",
      "banked",
      "difference",
    ];

    const data = this.data.map((transaction) => {
      const bankedValue = transaction.banked ? 'Yes' : 'No';

      return filterVal.map((key) => {
        if (key === 'banked') {
          return bankedValue;
        }
        return transaction[key];
      });
    });

    const totals = [
      "Total", 
      "", 
      this.formatPrice(this.calculateTotal(this.data, "topup")),
      this.formatPrice(this.calculateTotal(this.data, "total_sales")),
      this.formatPrice(this.calculateTotal(this.data, "cash_in_hand")),
      "",
      this.formatPrice(this.calculateTotal(this.data, "difference")),
    ];

    data.push(totals);

    excel.export_json_to_excel({
      header: tHeader,
      data,
      filename: this.getFileName(),
      autoWidth: this.autoWidth,
      bookType: this.bookType,
    });
    this.downloadLoading = false;
  });
},









    
    },
  };
  </script>
  